export default __webpack_public_path__ + "static/wards-home-video-55efc5e31d1012605ca9cf0fd112dee5.mp4";